import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxAutocompleteComponent } from 'ngx-angular-autocomplete';
import { Prediction } from 'src/app/models/location/googl-location.model';
import { CarRentalService } from 'src/app/services/car-rental-service/car-rental.service';
import { LocationService } from 'src/app/services/location/location.service';

@Component({
  selector: 'app-need-car-delivery',
  templateUrl: './need-car-delivery.component.html',
  styleUrls: ['./need-car-delivery.component.scss']
})
export class NeedCarDeliveryComponent implements OnInit {

  //#region I/O Variables
  @Input() times: Array<string> = [];
  @ViewChild('collectionCity') collectionCity: NgxAutocompleteComponent;
  minDateCollection: Date;
  maxDateReturn: Date;
  minDateDelivery: Date;
  maxDatePickUp: Date;
  public carDeliveryLocationForm: any;
  public showMoreOptions = false;
  public deliveryLocations: Prediction[] = [];
  public collectionCities: Prediction[] = [];
  filteredSelectedTime: string[];
  constructor(private _locationService: LocationService
    , private carRentalService: CarRentalService
    , private _router: Router
    , private alertService: AlertService) {
    this.minDateDelivery = new Date((new Date()).getTime() + 24*60*60*1000);
    this.minDateCollection = new Date();
  }

  ngOnInit(): void {
    this.initcarDeliveryLocationForm();
    this.carDeliveryLocationForm.deliveryTime = '10:00';
    this.carDeliveryLocationForm. collectionTime='10:00'
  }
  public dateSelect() {
    this.minDateCollection = this.carDeliveryLocationForm.deliveryDate;
    this.minDateDelivery = this.carDeliveryLocationForm.deliveryDate;
    this.minDateCollection = new Date(this.minDateCollection.getTime() + (2 * 24 * 60 * 60 * 1000));
  }

  public getcarDeliveryFilterdTime(){
    this.filteredSelectedTime = this.times.filter(time => time >= this.carDeliveryLocationForm.deliveryTime);
  }

  public onChangeCollectionLocation() {
    if (this.carDeliveryLocationForm.isEnableDifferentCollectionAddress) {
      this.carDeliveryLocationForm.collectionCity = '';
      this.carDeliveryLocationForm.collectionAddress = '';
    }
  }

  public onSubmitcarDeliveryLocationForm() {
    const currentUrl = '/car-rental/search/need-delivery';
    if (this.validateForm()) {
      this.carRentalService.carRentalNeedDeliverySearchCriteria = this.carDeliveryLocationForm;
      if (this._router.url === currentUrl) {
        this._router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
          this._router.navigate([currentUrl]);
        });
      } else {
        this._router.navigateByUrl(currentUrl);
      }
    }
  }

  public onSelectItem(event: any, type: number) {
    if (event) {
      if (type === 1) {
        this.carDeliveryLocationForm.deliveryCity = event;
      } else if (type === 2) {
        this.carDeliveryLocationForm.collectionCity = event;
      }
    }

  }

  public onEnterLocation(event, type: number) {
    if (event?.target?.value) {
      const value = event.target.value;
      if (value?.length >0) {
        this._locationService.googleLocation(value).subscribe(result => {
          if (result.wasSuccesfull==false) {
            if (type === 1) {
              this.deliveryLocations = result.data.predictions;
            } else if (type === 2) {
              this.collectionCities = result.data.predictions;
            }
          }
        });
      }
    }

  }
 
  private validateForm() {
    if (!this.carDeliveryLocationForm.deliveryCity) {
      this.alertService.danger('Please select delivery city.');
      return false;
    }
    else if (!this.carDeliveryLocationForm.deliveryAddress) {
      this.alertService.danger('Please fill delivery address.');
      return false;
    }

    else if (this.carDeliveryLocationForm.isEnableDifferentCollectionAddress) {
      if (!this.carDeliveryLocationForm.collectionCity) {
        this.alertService.danger('Please select collection city.');
        return false;
      }
      else if (!this.carDeliveryLocationForm.collectionAddress) {
        this.alertService.danger('Please fill collection address.');
        return false;
      }
    }

    else if (!this.carDeliveryLocationForm.deliveryDate) {
      this.alertService.danger('Please select delivery date.');
      return false;
    }

    else if (!this.carDeliveryLocationForm.deliveryTime) {
      this.alertService.danger('Please select delivery time.');
      return false;
    }


    else if (!this.carDeliveryLocationForm.collectionDate) {
      this.alertService.danger('Please select collection date.');
      return false;
    }

    else if (!this.carDeliveryLocationForm.collectionTime) {
      this.alertService.danger('Please select collection time.');
      return false;
    }

    return true;
  }

  private initcarDeliveryLocationForm(): void {
    this.carDeliveryLocationForm = {
      deliveryCity: '',
      deliveryAddress: '',
      isEnableDifferentCollectionAddress: false,
      collectionCity: '',
      collectionAddress: '',
      deliveryDate: '',
      deliveryTime: '',
      collectionDate: '',
      collectionTime: '',
      hasLiscence: true
    }
  }
}
